module.exports = __webpack_public_path__ + "img/Boy_030024.50376377.png";